<template>
  <div class="approvers" v-if="signers.length">
    <h3>
      {{ i18n.lbl_signatures() }}</h3>
    <div v-for="signer in signers" :key="signer.r" :class="{'rejected': signer.status === 'canceled', confirm: signer.status === 'confirmed'}">
      <span v-if="signer.status === 'confirmed'"><img src="/static/img/level-success.svg"/></span>
      <span v-else><img src="/static/img/level-cross.svg"/></span>
      <span>{{ signer.name_of }}</span>
      <span>{{ signer.approver_email }}</span>
      <span>{{ signer.approved_at }}</span>
    </div>
  </div>
</template>
  
  <script>
  import { withdrawUSDTService } from '@api/withdraw_usdt.service'
  import { i18n } from '@js/i18n'
  export default {
    name: 'CheckSignList',
    props: {
      id: {
        default: 0
      },
      isHistory: {
        default: false
      }
    },
    emits: ['getIds'],
    data () {
      return {
        signers: [],
        i18n
      }
    },
    async mounted () {
      let values
      if (this.isHistory) {
        const { data } = await withdrawUSDTService.getSignForHistory(this.id)
        values = data
      } else {
        const { data } = await withdrawUSDTService.getSigns(this.id)
        values = data
      }
      this.signers = values.map(el => {
        return {
          ...el,
          approved_at: this.i18n.d(el.approved_at),
          name_of: this.formatName(el.level)
        }
      })
      this.$emit('getIds', this.signers.map(el => el.approver_id))
    },
    methods: {
      formatName (lvl) {
        switch (lvl) {
          case 1:
            return this.i18n.lbl_level_1()
          case 2:
            return this.i18n.lbl_level_1()
          case 3:
            return this.i18n.lbl_level_2()
          case 4:
            return this.i18n.lbl_level_3()
          case 5:
            return this.i18n.lbl_level_4()
        }
      },
      formatTimestamp (isoString) {
        const date = new Date(isoString)
        const yy = String(date.getUTCFullYear()).slice(-2)
        const mm = String(date.getUTCMonth() + 1).padStart(2, '0')
        const dd = String(date.getUTCDate()).padStart(2, '0')
        const hh = String(date.getUTCHours()).padStart(2, '0')
        const min = String(date.getUTCMinutes()).padStart(2, '0')
        const sec = String(date.getUTCSeconds()).padStart(2, '0')
        return `${yy}-${mm}-${dd} ${hh}:${min}:${sec}`
      }
    }
  }
  </script>
  <style scoped lang="scss">
    @import '~scss/variables';
  .approvers {
    margin-top: 20px;
    img {
      max-width: 25px;
    }
  }
  .rejected {
    &:last-child {
      color: $error-red;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/vue/app/widrawalRequest/CheckSignList.vue